export enum ERedirectTo{
    NoWhere,
    Checkout
}